import VisuallyHidden from '@reach/visually-hidden';
import IconCheck from '@remote-com/norma/icons/check.svg';
import styled from 'styled-components';

import { Cell, Table } from '@/src/domains/pricing/Table';

export const TableContainer = styled.div`
  display: block;
  margin: 75px auto;
  overflow-x: auto;
  max-width: 100%;
  min-width: 100%;
`;

const FeatureLabelCell = styled(Cell)`
  box-sizing: border-box;
  max-width: 150px;
  ${({ theme }) => theme.typography.subHeadSM};
  color: var(--colors-darkBlue);
  padding: 20px;
  text-align: center;
`;

const ServiceLabelCell = styled(Cell)`
  box-sizing: border-box;
  max-width: 115px;
  ${({ theme }) => theme.typography.subHeadSM};
  color: var(--colors-darkBlue);
  padding: 20px;
`;

const BooleanValueCell = styled.div`
  color: var(--colors-irisBlue);
  display: flex;
  align-items: center;
  justify-content: center;
`;

function BooleanValue({ children }) {
  if (!children) {
    return <VisuallyHidden>Not included</VisuallyHidden>;
  }

  return (
    <BooleanValueCell>
      <VisuallyHidden>Included</VisuallyHidden>
      <IconCheck aria-hidden="true" />
    </BooleanValueCell>
  );
}

export function ServicesTable({ services, features }) {
  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <FeatureLabelCell />
            {features.map(({ featureName }, index) => (
              <FeatureLabelCell key={index}>{featureName}</FeatureLabelCell>
            ))}
          </tr>
        </thead>
        <tbody>
          {services.map(
            (
              {
                service,
                requiresOwnEntity,
                employsOnBehalf,
                ipProtection,
                laborLawCompliance,
                payrollLocalEntities,
                benefitsAdminManagement,
                paymentsContractor,
              },
              index
            ) => (
              <tr key={index}>
                <ServiceLabelCell>{service}</ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{requiresOwnEntity}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{employsOnBehalf}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{ipProtection}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{laborLawCompliance}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{payrollLocalEntities}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{benefitsAdminManagement}</BooleanValue>
                </ServiceLabelCell>
                <ServiceLabelCell>
                  <BooleanValue>{paymentsContractor}</BooleanValue>
                </ServiceLabelCell>
              </tr>
            )
          )}
        </tbody>
      </Table>
    </TableContainer>
  );
}
